import { defaultStatus } from '@/_schemas/status-input';

import type { TeamMemberFormSchema } from '../schemas';

export const defaultValues: Readonly<TeamMemberFormSchema> = {
  id: -1,
  first_name: '',
  last_name: '',
  biography: '',
  personal_email: '',
  work_email: '',
  hr_identifier: '',
  internal_extension: '',
  job_title: '',
  hired_on: '',
  pet_names: '',
  birthdate: '',
  termination: '',
  parent: null,
  interests: [],
  children_names: '',
  spouse_name: '',
  preferred_relationship: null,
  w2_withholdings: 0,
  tax_type: '',
  phone_numbers: [],
  status: defaultStatus,

  gender: null,
  tech_preference: null,
  t_shirt_size: null,

  profile_image: null,

  gallery: [],

  harvest: '',
  freshdesk: '',
  gusto: '',
  zoom: '',

  lockdown_override_pin: '',
} as const;
